module.exports = __webpack_public_path__ + "static/img/solution1.922f0be.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/solution1.png
// module id = jWob
// module chunks = 1